import { render, staticRenderFns } from "./BoxAgradecimento.vue?vue&type=template&id=b3776f70&scoped=true"
import script from "./BoxAgradecimento.vue?vue&type=script&lang=js"
export * from "./BoxAgradecimento.vue?vue&type=script&lang=js"
import style0 from "./BoxAgradecimento.vue?vue&type=style&index=0&id=b3776f70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3776f70",
  null
  
)

export default component.exports